"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var time_1 = require("../../helpers/time");
var reportcards_model_1 = require("../../models/reportcards-model");
var json_1 = require("../../../common/helpers/json");
var dcReportcardController = /** @class */ (function () {
    function dcReportcardController($scope, UserService) {
        var _this = this;
        this.currentUser = UserService.getCurrentUser();
        this.init = this.init.bind(this);
        this.init();
        $scope.$watch("vm.reportcard", function () {
            _this.init();
        });
    }
    dcReportcardController.prototype.init = function () {
        var _this = this;
        if (typeof this.reportcard !== "undefined") {
            this.reportcard.grades = this.reportcard.grades.map(function (grade) {
                grade.icon = (0, reportcards_model_1.getIcon)(grade.task.name);
                grade.statusDisplay = (0, reportcards_model_1.getReportcardStatusDisplay)(grade.status);
                return grade;
            });
            var driveDateTime = (0, time_1.dateTimeStringToDate)(this.reportcard.drive.drive_date +
                " " +
                this.reportcard.drive.start_time);
            this.drivedate = new Date(driveDateTime).toLocaleDateString("en-US", {
                weekday: "long",
                year: "numeric",
                month: "long",
                day: "numeric",
            });
            this.reportCardBegin = "";
            this.reportCardEnd = "";
            this.reportCardBegin = (0, time_1.formatDateTime)(driveDateTime, "h:mm A");
            this.reportCardEnd = (0, time_1.formatDateTime)((0, time_1.addMinutes)(driveDateTime, this.reportcard.drive.session_length), "h:mm A");
            if (this.reportcard.drive.instructor) {
                this.reportcard.drive.instructor.usermeta.forEach(function (meta) {
                    _this.reportcard.drive.instructor[meta.meta_key] = (0, json_1.isJson)(meta.meta_value)
                        ? JSON.parse(meta.meta_value)
                        : meta.meta_value;
                });
            }
            if (this.reportcard.drive.observation === true) {
                this.reportcard.drive.type.name =
                    this.reportcard.drive.type.name + " (Observation)";
            }
        }
    };
    return dcReportcardController;
}());
dcReportcardController.$inject = ["$scope", "UserService"];
exports.default = dcReportcardController;
